import React, { useState, useEffect } from "react";
import PersonalData from './LicenseSteps/PersonalStep';
import AssistantData from './LicenseSteps/AssistantStep';
import EducationAndCertificatesStep from './LicenseSteps/EducationAndCertificatesStep';
import IskData from './LicenseSteps/IskStep';
import AdditionalData from './LicenseSteps/AdditionalStep';
import DeclarationData from './LicenseSteps/DeclarationStep';
import { useNavigate, useLocation } from 'react-router-dom';

const MainDashboard = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    const steps = [
        PersonalData,
        AssistantData,
        EducationAndCertificatesStep,
        IskData,
        AdditionalData,
        DeclarationData,
    ];

    useEffect(() => {
        const fetchSteps = async () => {
            // If an initialStep was passed via navigation state, use it and stop loading
            if (location.state?.initialStep !== undefined) {
                setCurrentStep(location.state.initialStep);
                setIsLoading(false);
                return;
            }

            const accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                navigate('/portal');
                return;
            }

            try {
                const response = await fetch('https://portal.lsb.go.ke/account/steps/', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    // Map steps to their completion status
                    const stepStatus = [
                        data.step_1,
                        data.step_2,
                        data.step_3,
                        data.step_4,
                        data.step_5,
                        data.step_6
                    ];

                    // Find the first step that is false
                    const firstIncompleteStep = stepStatus.findIndex(step => step === false);
                    
                    if (firstIncompleteStep !== -1) {
                        setCurrentStep(firstIncompleteStep);
                    } else {
                        // All steps completed, redirect to final dashboard
                        navigate('/finalDashL');
                    }
                }
            } catch (error) {
                console.error('Error fetching steps:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSteps();
    }, [navigate, location.state]);

    const StepComponent = steps[currentStep];

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            console.log("All steps completed");
            navigate('/finalDashL');
        }
    };

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[60vh]">
                <svg className="animate-spin h-12 w-12 text-[#3d0707] mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span className="text-gray-600 text-lg font-medium">Loading your progress...</span>
            </div>
        );
    }

    return (
        <div className="px-4 lg:px-8 pt-4 container mx-auto">
            <h5 className="font-medium">Step <b className="italic text-[#3d0707]">{currentStep + 1} / {steps.length}</b></h5>

            <StepComponent onNext={handleNext} onBack={handleBack} />
        </div>
    );
};

export default MainDashboard;